import {Component} from '@angular/core';
import {NgbToast} from '@ng-bootstrap/ng-bootstrap';
import {ToastService} from './toast-service';

@Component({
  selector: 'app-toasts',
  template: `
    @for (toast of toastService.toasts(); track toast) {
      <ngb-toast class="toast-item"
                 [class.success]="toast.type === 'success'"
                 [class.error]="toast.type === 'danger'"
                 [class.warning]="toast.type === 'warning'"
                 [class.info]="!toast.type || toast.type === 'info'"
                 [autohide]="true" [delay]="toast.delay || 6000"
                 (hidden)="toastService.remove(toast)">
        <div class="toast-icon" aria-hidden="true">
          @if (toast.type === 'success') {
            <span>&#10003;</span>
          } @else if (toast.type === 'danger' || toast.type === 'warning') {
            <span>&#33;</span>
          } @else {
            <span>&#105;</span>
          }
        </div>
        <div class="toast-content">
          <p
            class="toast-title">{{ toast.header || (toast.type === 'success' ? 'สำเร็จ' : toast.type === 'danger' ? 'เกิดข้อผิดพลาด' : 'การแจ้งเตือน') }}</p>
          <p class="toast-text">{{ toast.body }}</p>
        </div>
        <button type="button" class="toast-close" (click)="toastService.remove(toast)" aria-label="ปิดการแจ้งเตือน">
          &#10005;
        </button>
        <span class="toast-progress" aria-hidden="true"></span>
      </ngb-toast>
    }
  `,
  host: {'class': 'toast-wrapper', 'style': 'z-index: 11000'},
  imports: [NgbToast],
  styleUrl: './toast-container.component.scss'
})
export class ToastsContainer {
  constructor(public toastService: ToastService) {
  }
}
